import { Search } from '@wix/wix-ui-icons-common/on-stage';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { TextField } from 'wix-ui-tpa/cssVars';
import { useTranslation } from '../../../../contexts/translation-context';
import { classes, st } from './country-list.st.css';
import { CountryOption } from './country-option';
import { useCountries } from '../use-countries';
import { useHover } from './use-hover';
export function CountryList(_ref) {
  var _countries$hoveredInd;
  let {
    selectedCountry,
    onSelectionChange
  } = _ref;
  const {
    t
  } = useTranslation();
  const searchInputRef = useRef(null);
  const [searchPhrase, setSearchPhrase] = useState('');
  const countries = useCountries(searchPhrase);
  const scrolled = useRef(false);
  const selectedCountryIndex = useMemo(() => {
    if (!selectedCountry) {
      return -1;
    }
    return countries.findIndex(country => country.longCountryCode === selectedCountry);
  }, [countries, selectedCountry]);
  const {
    ref: optionsContainerRef,
    hoveredIndex,
    hoverAtIndex,
    hoverNext,
    hoverPrevious
  } = useHover({
    initialIndex: selectedCountryIndex,
    listLength: countries.length
  });
  const hoveredCountryCode = (_countries$hoveredInd = countries[hoveredIndex]) == null ? void 0 : _countries$hoveredInd.longCountryCode;
  useEffect(() => {
    if (!scrolled.current) {
      scrolled.current = true;
      if (selectedCountryIndex > -1) {
        hoverAtIndex(selectedCountryIndex, {
          scrollPosition: 'center'
        });
      }
    }
  }, [selectedCountryIndex, hoverAtIndex]);
  const handleSearch = useCallback(event => {
    setSearchPhrase(event.target.value);
    hoverAtIndex(0, {
      scrollPosition: 'start'
    });
  }, [hoverAtIndex]);
  const handleKeyDown = useCallback(event => {
    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        hoverNext();
        break;
      case 'ArrowUp':
        event.preventDefault();
        hoverPrevious();
        break;
      case 'Enter':
        event.preventDefault();
        onSelectionChange(hoveredCountryCode);
        break;
    }
  }, [hoveredCountryCode, onSelectionChange, hoverNext, hoverPrevious]);
  const handleMouseMove = useCallback(index => {
    if (hoveredIndex !== index) {
      hoverAtIndex(index);
    }
  }, [hoverAtIndex, hoveredIndex]);
  const handleMouseDown = useCallback(event => {
    var _searchInputRef$curre;
    event.preventDefault();
    event.stopPropagation();
    (_searchInputRef$curre = searchInputRef.current) == null || _searchInputRef$curre.focus();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    onKeyDown: handleKeyDown,
    onMouseDown: handleMouseDown
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.search
  }, /*#__PURE__*/React.createElement(TextField, {
    ref: searchInputRef,
    prefix: /*#__PURE__*/React.createElement(Search, null),
    placeholder: t('field.phone.country-search-input.placeholder'),
    "aria-label": t('field.phone.country-search-input.aria-label'),
    autoFocus: true,
    value: searchPhrase,
    onChange: handleSearch
  })), /*#__PURE__*/React.createElement("div", {
    role: "listbox",
    ref: optionsContainerRef,
    className: classes.optionsContainer
  }, countries.map((country, index) => {
    return /*#__PURE__*/React.createElement("div", {
      role: "option",
      title: `${country.countryName} ${country.callingCode}`,
      "aria-selected": country.longCountryCode === selectedCountry,
      key: country.longCountryCode,
      className: st(classes.option, {
        hovered: index === hoveredIndex,
        selected: country.longCountryCode === selectedCountry
      }),
      onMouseMove: () => handleMouseMove(index),
      onClick: () => onSelectionChange(country.longCountryCode)
    }, /*#__PURE__*/React.createElement(CountryOption, {
      callingCode: country.callingCode,
      countryName: country.countryName,
      longCountryCode: country.longCountryCode
    }));
  })));
}
//# sourceMappingURL=country-list.js.map